import * as React from "react";
import { VisitorBlogsCardProps, VisitorBlogsProps } from "./typings";
import { UitkFigure, UitkImage } from "uitk-react-images";
import { Article as VisitorBlog } from "typings/microserviceModels/te-article-flex-module";
import { UitkCarousel } from "uitk-react-carousel";
import { AnalyticsConfig } from "uitk-react-utils";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { ViewLarge, Viewport, ViewSmall } from "bernie-view";
import { AspectRatioEnum } from "stores/thumbor/ThumborStore";
import { inject } from "mobx-react";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import {
  Action,
  FlexTrackingInfo,
  sendDelayedTrackEvent
} from "components/utility/analytics/FlexAnalyticsUtils";
import {
  UitkCard,
  UitkCardContent,
  UitkCardLink,
  UitkCardMedia,
  UitkCardTextSegment
} from "uitk-react-cards";
import { MediaAttribution } from "components/utility/MediaAttributionUtil";
import LazyLoad from "react-lazyload";
import { LazyLoaderPlaceHolder } from "components/utility/LazyLoaderPlaceholderWrapper";

@inject("thumbor", "analytics")
export class VisitorBlogs extends React.Component<VisitorBlogsProps> {
  private safelyResizeImage(visitorBlog: VisitorBlog) {
    const image: string = visitorBlog.media && visitorBlog.media.mediaUrl;

    return image && this.props.thumbor
      ? this.props.thumbor.safelyGenerateThumborizedImageUrl(
          image,
          600,
          300,
          this.props.context,
          AspectRatioEnum.DEFAULT,
          true,
          100
        )
      : image;
  }

  public render() {
    const articleKeyHelper = new ItemKeyHelper("top-articles");
    const context = this.props.context;

    if (
      !this.props.flexComponent.model.content ||
      this.props.flexComponent.model.empty ||
      !this.props.flexComponent.model.content ||
      !this.props.flexComponent.model.content.items ||
      !this.props.flexComponent.model.content.items.length
    ) {
      return null;
    }

    const visitorBlogs =
      this.props.flexComponent.model &&
      this.props.flexComponent.model.content &&
      this.props.flexComponent.model.content.items;

    let desktopVisitorBlogs = visitorBlogs;
    if (desktopVisitorBlogs) {
      desktopVisitorBlogs = desktopVisitorBlogs.filter(
        (poi, index) => (desktopVisitorBlogs.length >= 6 ? index < 6 : index < 3)
      );
    }

    const analytics: AnalyticsConfig = {
      id: "TG.LP.Dest.Articles",
      callback: (id, description) => {
        const flexTrackingInfo: FlexTrackingInfo = {
          moduleName: id,
          action: Action.SCROLL,
          linkName: description
        };
        sendDelayedTrackEvent(flexTrackingInfo, this.props.analytics);
      }
    };

    const l10n = this.props.l10n;
    const localisedHeading = `${l10n.formatText(
      "visitorBlogs.title",
      this.props.context.searchContext.location.name
    )}`;

    const carouselProps = {
      itemsVisible: { lg: 1, md: 1, sm: 1 },
      pageBy: 1,
      peekWidth: 24,
      buttonText: {
        nextButton: l10n.formatText("carousel.item.next"),
        prevButton: l10n.formatText("carousel.item.prev")
      }
    };

    let numberOfBlogs: number = 0;
    if (visitorBlogs && visitorBlogs.length) {
      numberOfBlogs = visitorBlogs.length;
    }

    return (
      <Viewport>
        <ViewSmall>
          <div
            className={`VisitorBlogs uitk-cell all-b-margin-six all-t-margin-six ${
              numberOfBlogs > 1 ? "VisitorBlogs-carousel" : ""
            }`}
            data-fm={this.props.flexComponent.fmId}
            data-fm-title-id={this.props.flexComponent.fmTitleId}
          >
            {numberOfBlogs > 1 && (
              <UitkCarousel
                headline={localisedHeading}
                analytics={analytics}
                carouselName={"Visitor Blogs"}
                className=""
                {...carouselProps}
              >
                {visitorBlogs.map((visitorBlog: VisitorBlog, index: number) => (
                  <VisitorBlogsCard
                    key={articleKeyHelper.next()}
                    visitorBlog={visitorBlog}
                    context={context}
                    position={index}
                    visitorBlogImageUrl={this.safelyResizeImage(visitorBlog)}
                    cardClassName="uitk-carousel-item"
                    l10n={l10n}
                  />
                ))}
              </UitkCarousel>
            )}
            {numberOfBlogs === 1 &&
              visitorBlogs.map((visitorBlog: VisitorBlog, index: number) => (
                <div key={articleKeyHelper.next()}>
                  <h3 className="uitk-type-heading-600 type__weight__700 all-b-margin-three">
                    {localisedHeading}
                  </h3>
                  <div className="uitk-cell">
                    <VisitorBlogsCard
                      visitorBlog={visitorBlog}
                      context={context}
                      position={index}
                      visitorBlogImageUrl={this.safelyResizeImage(visitorBlog)}
                      cardClassName=""
                      l10n={l10n}
                    />
                  </div>
                </div>
              ))}
          </div>
        </ViewSmall>
        <ViewLarge>
          <div
            className="VisitorBlogs uitk-cell all-cell-1-1 all-b-margin-six"
            data-fm={this.props.flexComponent.fmId}
          >
            {desktopVisitorBlogs &&
              desktopVisitorBlogs.length > 0 && (
                <div>
                  <h3 className="uitk-type-heading-600 type__weight__700 all-b-margin-three">
                    {localisedHeading}
                  </h3>
                  <div className="uitk-grid all-cell-1-3 all-x-gutter-three all-y-gutter-three">
                    {desktopVisitorBlogs.map((visitorBlog, index) => (
                      <div className="uitk-cell" key={articleKeyHelper.next()}>
                        <VisitorBlogsCard
                          visitorBlog={visitorBlog}
                          context={context}
                          position={index}
                          visitorBlogImageUrl={this.safelyResizeImage(visitorBlog)}
                          cardClassName=""
                          l10n={l10n}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
          </div>
        </ViewLarge>
      </Viewport>
    );
  }
}

export const VisitorBlogsCard = (props: VisitorBlogsCardProps) => {
  const attribution = MediaAttribution(props.visitorBlog.media, props.visitorBlog.name);

  return (
    <UitkCard className={props.cardClassName}>
      <UitkCardMedia>
        <UitkCardLink>
          <TrackedLink
            moduleName="TG.LP"
            href={props.visitorBlog.link}
            rfrr="Dest.Articles"
            linkName={props.visitorBlog.name}
          >
            {props.visitorBlog.name}
          </TrackedLink>
        </UitkCardLink>
        <UitkFigure>
          <LazyLoad
            placeholder={<LazyLoaderPlaceHolder name={props.visitorBlog.name} />}
            offset={250}
          >
            <UitkImage
              alt={attribution && attribution.attributionAltText}
              src={props.visitorBlogImageUrl}
            />
          </LazyLoad>
          {attribution && attribution.attributionText}
        </UitkFigure>
        <UitkCardContent>
          <UitkCardTextSegment>
            <h4 className="uitk-type-heading-400">{props.visitorBlog.name}</h4>
            <p>{props.visitorBlog.description}</p>
          </UitkCardTextSegment>
        </UitkCardContent>
      </UitkCardMedia>
    </UitkCard>
  );
};

export default VisitorBlogs;
